import { IconButton } from 'modules/IconButton';
import { VisuallyHidden } from 'modules/VisuallyHidden';
import { Falcon } from 'modules/macro';
export function ScrollButton(props) {
    const { direction, label, onClick } = props;
    return (<IconButton appearance="ghost" size="small" onClick={onClick}>
      {direction === 'left' ? <Falcon icon="chevron-left"/> : <Falcon icon="chevron-right"/>}
      <VisuallyHidden>{label}</VisuallyHidden>
    </IconButton>);
}
